namespace UMouseEvent {
  export const hasModifier = (event: MouseEvent) =>
    event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
}

export default UMouseEvent;
